$(document).ready(function() {
  // get all sentences
  var sentences = $(".footer__primary__sentences__sentence").map(function() {
    return $(this).text();
  }).get();

  var currentSentenceIndex = 0;
  var currentCharIndex = 0;
  var isDeleting = false;

  function typeWriter() {
    var sentence = sentences[currentSentenceIndex]; // get current sentence
    var speed = isDeleting ? 50 : 110; // set speed

    if (!isDeleting && currentCharIndex === sentence.length) {
      // wait 1500 milliseconds after the sentence is completely typed
      setTimeout(function() {
        isDeleting = true; // start deleting
      }, 1500);
    } else if (isDeleting && currentCharIndex === 0) { // sentence is completely deleted
      isDeleting = false; // go to next sentence
      currentSentenceIndex = (currentSentenceIndex + 1) % sentences.length; // loop through sentences
    }

    // get current text
    var currentText = isDeleting ? sentence.substring(0, currentCharIndex - 1) : sentence.substring(0, currentCharIndex + 1);
    $('.footer__primary__sentences__writer').text(currentText); // set current text
    currentCharIndex = isDeleting ? currentCharIndex - 1 : currentCharIndex + 1; // increment or decrement char index

    setTimeout(typeWriter, speed); // call typeWriter function again
  }

  typeWriter(); // start typing
});
